export default __webpack_public_path__ + "static/OperatorMono-Book_Web-acd7651e2ed3d525b6ac655a084f2dd8.woff2";